import React, { useEffect, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import productData from "../data/products.json";

function PrinterSlider() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const filtered = productData.filter(
      (item) =>
        item.category &&
        (item.category.toLowerCase().includes("home-printer") ||
          item.category.toLowerCase().includes("inkjet-printer"))
    );
    setProducts(filtered);
  }, []);

  const formatCategory = (str) =>
    str.replace(/[-_]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  const productsWithData = useMemo(() => {
    return products.map((item) => ({
      ...item,
      rating: (Math.random() * 1 + 4).toFixed(1),
      reviews: Math.floor(Math.random() * 500) + 50,
      formattedCategory: formatCategory(item.category || "Printer"),
    }));
  }, [products]);

  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login-now");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity++;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));

    // 🔥 Trigger header update instantly (fixes no-refresh issue)
    window.dispatchEvent(new Event("cart-updated"));

    toast.success(`${product.name} added to cart!`);
  };

  return (
    <section
      className="tour-area position-relative bg-top-center overflow-hidden space bg-no-repeat"
      id="service-sec"
      style={{ backgroundImage: "url(/assets/img/bg/tour_bg_1.jpg)" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="title-area text-center">
              <span className="sub-title">Shop Smart</span>
              <h2 className="sec-title">Home & Inkjet Printers</h2>
              <p className="sec-text">
                Browse our curated collection of reliable, high quality home and
                inkjet printers designed for fast, affordable and smart
                printing.
              </p>
            </div>
          </div>
        </div>

        {/* ==== SLIDER ==== */}
        <div className="slider-area tour-slider">
          <Swiper
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
              1300: { slidesPerView: 4 },
            }}
            spaceBetween={24}
            grabCursor={true}
            loop={productsWithData.length > 4} // FIXED LOOP WARNING
            className="swiper th-slider has-shadow slider-drag-wrap"
          >
            {productsWithData.map((item) => {
              const img =
                item.image || item.imageUrl || "/assets/images/placeholder.png";
              const finalPrice = item.salePrice || item.price;

              return (
                <SwiperSlide key={item.id}>
                  <div className="tour-box th-ani gsap-cursor">
                    <div className="tour-box_img global-img">
                      <img src={img} alt={item.name} />
                    </div>

                    <div className="tour-content">
                      <h3 className="box-title">
                        <Link to={`/product-details/${item.id}`}>
                          {item.name}
                        </Link>
                      </h3>

                      <div className="tour-rating">
                        ⭐ {item.rating} ({item.reviews} reviews)
                      </div>

                      <h4 className="tour-box_price">
                        <span className="currency">${finalPrice}</span>
                      </h4>

                      <div className="tour-action">
                        <span>
                          <i className="fa-light fa-tags" />
                          {item.formattedCategory}
                        </span>

                        <button
                          className="th-btn style4 th-icon"
                          onClick={() => handleAddToCart(item)}
                        >
                          Add Now
                        </button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default PrinterSlider;
